export default {
  userLanguage: 'English'
}
